import { useTranslation } from 'react-i18next';

import { Tabs } from '@treams/treams-ui';

import useFeature from '../packages/kakapo-ui-application/hooks/useFeature';

export default function ViewerFeedbackTabs() {
	const { t } = useTranslation();

	const hasFeedback = useFeature('2021.feedback');
	const hasCompliments = useFeature('2021.compliments');
	const hasSharedFeedback = useFeature('2024.feedback.share');

	return (
		<Tabs.Container>
			{hasFeedback && (
				<Tabs.Item title={t('feedback.tab.incoming.title')} selected path="/feedback" />
			)}
			{hasFeedback && <Tabs.Item title={t('feedback.tab.outgoing.title')} path="/feedback/given" />}
			{hasSharedFeedback && (
				<Tabs.Item title={t('feedback.tab.shared.title')} path="/feedback/shared" />
			)}
			{hasCompliments && (
				<Tabs.Item title={t('feedback.tab.compliments.title')} path="/feedback/compliments" />
			)}
		</Tabs.Container>
	);
}
